<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-layout justify-center wrap pt-8>
          <v-flex xs12>
            <v-card>
              <v-flex xs12>
                <v-card outlined color="#434343" class="mx-auto">
                  <v-layout justify-end wrap>
                    <v-flex xs10 px-5 align-self-end text-right>
                      <v-icon
                        color="white"
                        size="15"
                        @click="$refs.showImage.click()"
                        >mdi-folder-edit-outline</v-icon
                      >
                      <span
                        style="
                          color: white;
                          font-family: nunitosansregular;
                          font-size: 12px;
                        "
                        >Edit Photo</span
                      >
                      <input
                        v-show="false"
                        accept="image/*"
                        id="file"
                        ref="showImage"
                        multiple="multiple"
                        type="file"
                        @change="showImage"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center wrap>
                    <v-flex xs12 sm6 md6 text-center>
                      <v-layout justify-center wrap pt-6 pb-5 pt-xl-6>
                        <v-flex xs12 v-if="student.user">
                          <v-avatar size="100">
                            <v-img :src="mediaURL + student.user.photo" />
                          </v-avatar>
                        </v-flex>
                        <v-flex xs12 v-if="student.user">
                          <span
                            style="
                              color: #ffffff;
                              font-family: nunitosanssemibold;
                              font-size: 19px;
                            "
                            >{{ student.user.firstName }}
                            {{ student.user.lastName }}</span
                          >
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 xl2 pt-2 v-if="student.class">
                          <v-btn color="#9B8DFD" small rounded>
                            <span
                              style="
                                color: #ffffff;
                                font-family: nunitosansbold;
                              "
                            >
                              {{ student.class.className }}</span
                            >
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg3 xl2 pt-2>
                          <v-btn rounded outlined small color="white"
                            ><span
                              style="
                                color: #ffffff;
                                font-family: nunitosansregular;
                                text-transform: none;
                              "
                              >Adm. No.: {{ student.admissionnumber }}</span
                            ></v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md6 pa-4 pb-5 pt-1 v-if="attendence">
                      <v-card dark rounded="lg" color="#474747">
                        <v-layout justify-center wrap>
                          <v-flex xs12 sm7 md7 pt-3 px-2 px-sm-0>
                            <v-layout justify-start wrap>
                              <v-flex xs7 text-left>
                                <span
                                  style="
                                    font-family: nunitosansbold;
                                    font-size: 13px;
                                  "
                                  >Attendance Report</span
                                ><br />
                                <span
                                  style="
                                    color: #ffba00;
                                    font-family: nunitosansbold;
                                    font-size: 13px;
                                  "
                                  >{{ currentMonth }}</span
                                >
                              </v-flex>
                              <v-flex
                                xs5
                                pt-2
                                v-if="attendence.hasAttendanceTaken"
                              >
                                <v-btn
                                  color="#9B8DFD"
                                  small
                                  block
                                  rounded
                                  v-if="attendence.isPresent == true"
                                >
                                  <span
                                    style="
                                      color: #ffffff;
                                      font-family: nunitosansregular;
                                    "
                                  >
                                    PRESENT</span
                                  >
                                </v-btn>
                                <v-btn
                                  color="#9B8DFD"
                                  small
                                  block
                                  rounded
                                  v-if="attendence.isPresent == false"
                                >
                                  <span
                                    style="
                                      color: #ffffff;
                                      font-family: nunitosansregular;
                                    "
                                  >
                                    Absent</span
                                  >
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-layout justify-start wrap>
                              <v-flex xs5 sm5 md4 lg3>
                                <v-layout justify-center wrap>
                                  <v-flex xs12 text-left>
                                    <span
                                      style="
                                        color: #ffffff;
                                        font-family: nunitosanslight;
                                        font-size: 29px;
                                      "
                                      >{{
                                        attendence.numberOfDaysPresent
                                      }}</span
                                    >
                                  </v-flex>
                                  <v-flex xs12 sm12 md12 lg12 xl12 text-left>
                                    <span
                                      style="
                                        font-family: nunitosansregular;
                                        font-size: 13px;
                                        color: #b7b7b7;
                                      "
                                      >Days Present</span
                                    >
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs1 pt-4>
                                <span>/</span>
                              </v-flex>
                              <v-flex xs6 sm6 md3 text-center pt-4>
                                <v-layout wrap justify-center>
                                  <v-flex xs12>
                                    <span
                                      style="
                                        color: #ffffff;
                                        font-family: nunitosansbold;
                                        font-size: 15px;
                                      "
                                      >{{ attendence.numberOfDays }}</span
                                    ><br />
                                  </v-flex>
                                  <v-flex xs12 text-center>
                                    <span
                                      style="
                                        font-family: nunitosansregular;
                                        font-size: 13px;
                                        color: #b7b7b7;
                                      "
                                      >Days of this month</span
                                    >
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4 md4 pt-6 text-center>
                            <v-progress-circular
                              :size="65"
                              :width="5"
                              :value="attendence.percentage"
                              color="#FFBA00"
                            >
                              <span style="color: #ffffff; font-size: 12px"
                                >{{ attendence.percentage }}%</span
                              >
                            </v-progress-circular>
                            <v-flex text-center xs12 sm12 md12 py-2>
                              <span
                                style="
                                  color: #b7b7b7;
                                  font-family: nunitosansregular;
                                  font-size: 13px;
                                "
                                >Todays Attendance Percentage</span
                              >
                            </v-flex>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout justify-center wrap py-2>
                          <v-flex xs10>
                            <span
                              style="
                                color: #ffffff;
                                font-family: nunitosansregular;
                                font-size: 13px;
                              "
                              >Click here for Detailed Report</span
                            >
                          </v-flex>
                          <v-flex xs1 @click="isReport = true">
                            <v-icon style="cursor: pointer" color="#FFBA00"
                              >mdi-arrow-right</v-icon
                            >
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-card>
              </v-flex>
              <v-layout
                justify-start
                wrap
                py-4
                v-if="!isReport && achive.length > 0"
              >
                <v-flex xs12 sm6 md3 text-center>
                  <v-layout justify-center wrap>
                    <v-flex xs4 text-right pr-2>
                      <v-icon color="#FFBA00">mdi-trophy-outline</v-icon>
                    </v-flex>
                    <v-flex xs8 text-left>
                      <span style="color: #00000; font-family: nunitosansbold"
                        >Achievements</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout
                justify-start
                wrap
                v-if="!isReport && achive.length > 0"
              >
                <v-flex xs12 sm12 md12 lg10 pr-12>
                  <v-layout justify-start pl-12 wrap>
                    <v-flex
                      xs12
                      sm12
                      md4
                      lg4
                      pa-2
                      v-for="(item, i) in achive"
                      :key="i"
                    >
                      <v-card color="#FFFFFF">
                        <v-card-text>
                          <v-flex xs12>
                            <span
                              style="
                                color: #ffba00;
                                font-family: nunitosansbold;
                              "
                            >
                              {{ item.title }}</span
                            >
                            <br />
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosansbold;
                              "
                              >{{ item.description }}</span
                            >
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 md4 lg4 pa-2>
                      <v-card dark color="#FFFFFF">
                        <v-card-text>
                          <v-flex xs12>
                            <span
                              style="
                                color: #ffba00;
                                font-family: nunitosansbold;">
                              2nd Position</span
                            >
                            <br />
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosansbold;"
                              >100 Meters Running</span
                            >
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg3 pa-2>
                      <v-card dark color="#FFFFFF">
                        <v-card-text>
                          <v-flex xs12>
                            <span
                              style="
                                color: #ffba00;
                                font-family: nunitosansbold;"
                              >2nd Rank</span
                            >
                            <br />
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosansbold;"
                              >1st Term Exam
                            </span>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-flex> -->
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider v-if="!isReport"></v-divider>
              <v-layout justify-center wrap v-if="!isReport">
                <v-flex xs12>
                  <v-card-text>
                    <v-layout justify-center wrap py-5>
                      <v-flex xs12 sm12 md5>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 18px;
                          "
                          >Student Information</span
                        >
                        <v-layout justify-center wrap py-5>
                          <v-flex xs2 sm2 md1 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/male black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Gender</span>
                            <br />
                            <span class="content" v-if="student.user">{{
                              student.user.gender
                            }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/cake black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">DOB</span>
                            <br />
                            <span class="content" v-if="student.user">{{
                              student.user.dob.slice(0, 10)
                            }}</span>
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/phone iphone black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Contact</span>
                            <br />
                            <span class="content" v-if="student.user">{{
                              student.user.phone
                            }}</span>
                            <br />
                            <span class="content" v-if="student.user">{{
                              student.user.phone2
                            }}</span>
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/home black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Address</span>
                            <br />
                            <span class="content" v-if="student.user">{{
                              student.user.address
                            }}</span>
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/email black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Email</span>
                            <br />
                            <span class="content" v-if="student.user">{{
                              student.user.email
                            }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md4 align-self-end>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 18px;
                          "
                          >Parent Information</span
                        >
                        <v-layout justify-center wrap py-5>
                          <v-flex xs3 sm2 md2 pt-2 v-if="student.father">
                            <v-avatar size="40">
                              <v-img :src="mediaURL + student.father.photo" />
                            </v-avatar>
                          </v-flex>
                          <v-flex xs9 sm10 md10>
                            <span class="heading">Fathers Name</span>
                            <br />
                            <span class="content" v-if="student.father">{{
                              student.father.name
                            }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-center wrap pb-5>
                          <v-flex xs3 sm2 md2 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/phone iphone black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs9 sm10 md10>
                            <span class="heading">Contact</span>
                            <br />
                            <span class="content" v-if="student.father">{{
                              student.father.phone
                            }}</span>
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs3 sm2 md2 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/email black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs9 sm10 md10>
                            <span class="heading">Email</span>
                            <br />
                            <span class="content" v-if="student.father">{{
                              student.father.email
                            }}</span>
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs3 sm2 md2 pt-2 v-if="student.mother">
                            <v-avatar size="40">
                              <v-img :src="mediaURL + student.mother.photo" />
                            </v-avatar>
                          </v-flex>
                          <v-flex xs9 sm10 md10>
                            <span class="heading">Mothers Name</span>
                            <br />
                            <span class="content" v-if="student.mother">{{
                              student.mother.name
                            }}</span>
                          </v-flex> </v-layout
                        ><v-layout justify-center wrap pb-5>
                          <v-flex xs3 sm2 md2 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/phone iphone black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs9 sm10 md10>
                            <span class="heading">Contact</span>
                            <br />
                            <span class="content" v-if="student.mother">{{
                              student.mother.phone
                            }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-center wrap pb-5>
                          <v-flex xs3 sm2 md2 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/email black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs9 sm10 md10>
                            <span class="heading">Email</span>
                            <br />
                            <span class="content" v-if="student.mother">{{
                              student.mother.email
                            }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md2 text-right>
                        <v-dialog v-model="editdialog" max-width="700px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              :ripple="false"
                              size="16"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-folder-edit-outline</v-icon
                            >
                          </template>
                          <v-card v-if="student.user">
                            <v-card-text>
                              <v-layout justify-start wrap pt-5>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.user.firstName"
                                    class="text"
                                    label="First Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.user.lastName"
                                    class="text"
                                    label="Last Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-select
                                    dense
                                    label="Gender"
                                    outlined
                                    class="text"
                                    v-model="student.user.gender"
                                    hide-details
                                    :items="genders"
                                  >
                                  </v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="student.user.dob"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="student.user.dob"
                                        label="DOB"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="student.user.dob"
                                      max="2000-01-1"
                                      no-title
                                      scrollable
                                    >
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="
                                          $refs.menu.save(student.user.dob)
                                        "
                                      >
                                        OK
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.admissionnumber"
                                    class="text"
                                    label="Admission Number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.user.email"
                                    class="text"
                                    label="Email"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.user.phone"
                                    class="text"
                                    label="Contact"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.user.phone2"
                                    class="text"
                                    label="Contact"
                                    outlined
                                    type="number"
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 pa-2>
                                  <v-text-field
                                    v-model="student.user.address"
                                    class="text"
                                    label="Address"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.father.name"
                                    class="text"
                                    label="Fathers Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.father.phone"
                                    class="text"
                                    label="Father Contact"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.father.email"
                                    class="text"
                                    label="Father Email"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.mother.name"
                                    class="text"
                                    label="Mother Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.mother.phone"
                                    class="text"
                                    label="Mother Contact"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="student.mother.email"
                                    class="text"
                                    label="Mother Email"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-layout justify-center wrap>
                                <v-flex xs6 sm4 px-2>
                                  <v-btn
                                    block
                                    tile
                                    color="#757575"
                                    outlined
                                    :ripple="false"
                                    depressed
                                    @click="editdialog = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-flex>
                                <v-flex xs6 sm4 px-2>
                                  <v-btn
                                    tile
                                    block
                                    dark
                                    color="#FF1313"
                                    depressed
                                    class="text-capitalize"
                                    :ripple="false"
                                    @click="edit()"
                                  >
                                    Save
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <span
                          style="
                            font-family: nunitosansregular;
                            font-size: 12px;
                          "
                          >Edit Information</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap v-if="!isReport">
                <v-flex xs11>
                  <IndividualPerformance v-bind:storage="id" />
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap py-5 v-if="student.class">
                <v-flex xs11 v-if="!isReport">
                  <OverallPerformance
                    v-bind:storage="student.class"
                    v-bind:student="id"
                  />
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap v-if="isReport">
                <v-flex xs11>
                  <ViewAttendance v-bind:storage="id" />
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import IndividualPerformance from "@/components/Students/individualPerformance";
import OverallPerformance from "@/components/Students/overallPerformance";
import ViewAttendance from "@/components/Students/viewAttendance";
export default {
  components: {
    IndividualPerformance,
    OverallPerformance,
    ViewAttendance,
  },
  props: ["id"],
  data() {
    return {
      dates: new Date().toISOString().substr(0, 10),
      hover: false,
      appLoading: false,
      ServerError: false,
      editdialog: false,
      menu: false,
      isReport: false,
      cgpi: 50,
      student: [],
      attendence: [],
      classArray: [],
      individual: [],
      achive: [],
      currentMonth: "",
      file1: null,
      genders: ["Male", "Female", "Other"],
    };
  },
  beforeMount() {
    let ndate = new Date().toISOString().substr(5, 2);
    var month = new Array();
    month["01"] = "January";
    month["02"] = "February";
    month["03"] = "March";
    month["04"] = "April";
    month["05"] = "May";
    month["06"] = "June";
    month["07"] = "July";
    month["08"] = "August";
    month["09"] = "September";
    month["10"] = "October";
    month["11"] = "November";
    month["12"] = "December";
    this.currentMonth = month[ndate];
  },
  mounted() {
    this.getData();
    this.getAttendence();
    this.getAchive();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/student/get",
        params: {
          id: this.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.student = response.data.data;
          this.student.user.dob = this.student.user.dob.slice(0, 10);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getAchive() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/achievement/getlist",
        params: {
          student: this.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.achive = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getAttendence() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/attendance/student/thismonth",
        params: {
          student: this.id,
          date: this.dates,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.attendence = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    showImage(e) {
      this.file1 = e.target.files[0];
      console.log(e);
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file1.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreview = true;
      if (this.file1) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
          reader.readAsDataURL(this.file1);
        }
        this.uploadImage();
      }
    },
    uploadImage() {
      let formData = new FormData();
      formData.append("photo", this.file1);
      formData.append("id", this.student.user._id);
      axios({
        method: "POST",
        url: "/User/adminUploadImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.showPreview = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      var user = {};
      user["firstName"] = this.student.user.firstName;
      user["lastName"] = this.student.user.lastName;
      user["phone"] = this.student.user.phone;
      user["phone2"] = this.student.user.phone2;
      user["email"] = this.student.user.email;
      user["gender"] = this.student.user.gender;
      user["dob"] = this.student.user.dob;
      user["fatherName"] = this.student.father.name;
      user["fatherMobile"] = this.student.father.phone;
      user["fatherEmail"] = this.student.father.email;
      user["motherName"] = this.student.mother.name;
      user["motherMobile"] = this.student.mother.phone;
      user["motherEmail"] = this.student.mother.email;
      user["id"] = this.id;
      axios({
        method: "POST",
        url: "/student/edit",
        data: user,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.msg = "Student Update Successully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.editdialog = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.heading {
  color: #4d4d4d;
  font-family: nunitosanslight;
  font-size: 12px;
}
.content {
  color: #000000;
  font-family: nunitosansregular;
}
.subject {
  color: #4d4d4d;
  font-family: nunitosansregular;
  font-size: 12px;
}
</style>